import { render } from "./audit2.vue?vue&type=template&id=4cb0a87f&scoped=true"
import script from "./audit2.vue?vue&type=script&lang=js"
export * from "./audit2.vue?vue&type=script&lang=js"

import "./audit2.vue?vue&type=style&index=0&id=4cb0a87f&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/sathikash_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb0a87f"]])

export default __exports__